import { COLOR_PALETTE } from 'constants/ui';

/**
 * Ensures the card spans the FULL width of the Documents content area regardless
 * of the ancestor flex/grid context. Without this, a flex-column parent may not
 * auto-stretch the Card (display:block) child to 100% when the card has explicit
 * size constraints from its inner layout. `mb` separates the card from the
 * document tree/viewer grid below it.
 */
export const fullWidthWrapperStyles = {
  width: '100%',
  mb: 2,
};

export const listStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const rowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  padding: '12px 14px',
  borderRadius: '10px',
  border: ({ palette }) =>
    `1px solid ${palette.mode === 'dark' ? palette.primary.main : COLOR_PALETTE.BLUE[2]}`,
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? palette.primary.soft : COLOR_PALETTE.BLUE[1],
  cursor: 'pointer',

  '&:hover': {
    backgroundColor: ({ palette }) =>
      palette.mode === 'dark' ? palette.background.hoverHighlight : COLOR_PALETTE.BLUE[2],
  },
};

export const rowCompletedStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  padding: '12px 14px',
  borderRadius: '10px',
  // Dark: a solid success.dark fill makes the whole row a harsh saturated-green block and drops
  // the secondary meta text below contrast. Use a soft green tint + a visible green border (matches
  // the running-row pattern) so the row keeps text.primary/secondary legible. Light unchanged.
  border: ({ palette }) =>
    `1px solid ${palette.mode === 'dark' ? palette.success.main : palette.success.light}`,
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? palette.success.soft : palette.success.light,
  cursor: 'pointer',

  '&:hover': {
    opacity: 0.9,
  },
};

export const rowLeadingStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  flex: 1,
  minWidth: 0,
};

/** Stacks the primary label and sub-line vertically so custom typography variants
 * (medium14, regular12) that lack a variantMapping don't inline-bleed together. */
export const textColumnStyles = {
  display: 'flex',
  flexDirection: 'column',
};

export const rowFailedStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  padding: '12px 14px',
  borderRadius: '10px',
  border: ({ palette }) =>
    `1px solid ${palette.mode === 'dark' ? palette.error.dark : palette.error.light}`,
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? palette.error.soft : `${palette.error.light}33`,
};

export const failedMetaStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const rowMetaStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const rowTrailingStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
};

export const cancelButtonStyles = {
  minWidth: 0,
  padding: '2px 6px',
};
